// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import kbLibraryEntity from './entities/kb-library.json';
import kbLibraryMenu from '../pages/kb-library/menu.json';
import kbLibraryFullForm from '../pages/kb-library/forms/full.json';
import kbLibraryContextForm from '../pages/kb-library/forms/context.json';
import kbLibraryMiniForm from '../pages/kb-library/forms/mini.json';
import kbLibraryLookupForm from '../pages/kb-library/forms/lookup.json';
import kbLibraryTableView from '../pages/kb-library/views/table.json';
import kbLibraryCardsView from '../pages/kb-library/views/cards.json';
import kbLibraryDashboardView from '../pages/kb-library/views/dashboard.json';

/** Тип запису «Бібліотека» зі сторінками пакета: меню, форми та подання з pages/kb-library/. */
export const kbLibraryDefinition: IRecordTypeDefinition = {
  ...kbLibraryEntity,
  views: assembleViewSet({
      table: kbLibraryTableView,
      cards: kbLibraryCardsView,
      dashboard: kbLibraryDashboardView,
  }),
  form: kbLibraryFullForm,
  forms: { full: kbLibraryFullForm, context: kbLibraryContextForm, mini: kbLibraryMiniForm, lookup: kbLibraryLookupForm },
  menu: kbLibraryMenu,
} as IRecordTypeDefinition;
